import $ from 'jquery';
import { notify } from '../notifications';

const CALL_DELAY = 1000;

function submitHandler(submitSelector, handler) {
    let calledAt;
    $('.common-form-error').hide();
    $('.common-form-success-message').hide();
    $(submitSelector).on('click', async function () {
        if (calledAt && new Date() - calledAt < CALL_DELAY) {
            return;
        }
        calledAt = new Date();
        $('.common-form-error').hide();
        $('.common-form-success-message').hide();
        $('.floating-input').removeClass('error');
        // Кнопка занята, пока идёт запрос. Отклик должен быть виден
        // в первом кадре, а ответ сервера приходит через сотни
        // миллисекунд: без этого человек жмёт второй раз и считает,
        // что не сработало (bod-knowledge ui/response-time.md).
        //
        // Одно место на все формы: кнопок сохранения больше десятка,
        // и дописывать каждую по отдельности — значит однажды забыть.
        const $button = $(this);
        $button.addClass('is-busy');
        if ($button.is('button')) $button.prop('disabled', true);
        try {
            await handler();
            notify('Изменения сохранены', 'success');
        } catch (e) {
            if (e && e.handled) return;

            if (e &&
                e.response &&
                e.response.data &&
                e.response.data.errors &&
                e.response.data.errors.length &&
                e.response.status === 400
            ) {
                // Человеческий текст есть не у всех проверок. Там, где
                // его нет, прежде не показывалось вообще ничего: кнопка
                // нажималась, форма не сохранялась, экран молчал — и
                // человек не понимал, что от него хотят (QA 17.10,
                // анкета активности).
                const explained = e.response.data.errors
                    .map(error => error.formattedMessage)
                    .filter(Boolean);
                notify(
                    explained.length
                        ? explained[0]
                        : 'Не удалось сохранить: проверьте, всё ли заполнено',
                    'error',
                );
                for (const error of e.response.data.errors) {
                    // Через атрибут, а не `#id`: в именах полей анкеты
                    // есть точки и скобки, и селектор по идентификатору
                    // на них разваливается молча.
                    if (!error.param) continue;
                    const $field = $(`[id="${error.param}"]`);
                    if ($field.length && !$field.hasClass('error')) {
                        $field.addClass('error');
                    }
                }
                return;
            }

            notify('Что-то пошло не так. Попробуйте позже.', 'error');

            console.error(e);
            if (e.response) {
                console.log(e.response);
            }
        } finally {
            // Снимаем в любом исходе, в том числе на раннем возврате
            // по обработанной ошибке: иначе кнопка останется занятой
            // навсегда, и человек не сможет повторить.
            $button.removeClass('is-busy');
            if ($button.is('button')) $button.prop('disabled', false);
        }
    });
};

export {
    submitHandler
};
